<template>
    <form @submit.prevent="handleSubmit">
        <div class="row">
            <div class="col-md-3">
                <input-classic @input="value => handleChange('name', value)" :required="true" placeholder="Nom *"
                               :error="errors.name" v-model="data.name"/>
            </div>
            <div class="col-md-3">
                <input-classic @input="value => handleChange('email', value)" :required="true"
                               placeholder="Adresse e-mail *" type="email" :error="errors.email"
                               v-model="data.email"/>
            </div>
            <div class="col-md-3">
                <input-classic @input="value => handleChange('phone', value)" placeholder="Téléphone"
                               :error="errors.phone" v-model="data.phone"/>
            </div>
            <div class="col-md-3">
                <div class="Form__group">
                    <multiselect
                        open-direction="bottom"
                        class="Select"
                        :searchable="false"
                        :show-labels="false"
                        :placeholder="$campusLabel"
                        @select="value => handleChange('campus_id', value)"
                        key="id"
                        :allow-empty="false"
                        :loading="loadingCampuses"
                        :options="campuses"
                        label="name"
                        v-model="data.campus">
                        <span slot="noOptions">Aucun élément.</span>
                    </multiselect>
                    <span class="form-error" v-if="errors.campus_id">{{ errors.campus_id[0] }}</span>
                </div>
            </div>
        </div>
        <div v-if="subjects.length > 0" class="Form__group">
            <multiselect
                open-direction="bottom"
                class="Select"
                :searchable="false"
                :show-labels="false"
                placeholder="Sujet"
                @select="value => handleChange('subject', value)"
                :allow-empty="false"
                :options="subjects"
                v-model="data.subject">
                <span slot="noOptions">Aucun élément.</span>
            </multiselect>
            <span class="form-error" v-if="errors.subject">{{ errors.subject[0] }}</span>
        </div>
        <input-classic @input="value => handleChange('message', value)" :required="true" placeholder="Message *"
                       :error="errors.message" v-model="data.message"
                       type="textarea"/>
        <div class="text-center">
            <button :disabled="sending" type="submit" class="Btn Btn--primary Btn--block">
                <i v-if="sending" class="fas fa-spinner fa-spin"></i>
                <span v-else>Envoyer <i class="fas fa-caret-right m-l-5"></i></span>
            </button>
        </div>
    </form>
</template>
<script>
    import Multiselect from 'vue-multiselect'
    import 'vue-multiselect/dist/vue-multiselect.min.css';
    import {actions, getters} from "../store";
    import validate from "../validator/validator";
    import Rules from "../validator/rules";
    import {isEmpty} from "../utils";
    import Api from "../services/Api";
    import ModalBus from "../eventBus";
    import ContactType from "../enums/ContactType";
    import InputClassic from "./InputClassic";
    import Token from "../services/Token";

    export default {
        components: {InputClassic, Multiselect},
        props: {
            type: {
                type: String,
                default: ContactType.General
            },
            subjects: {
                type: Array,
                default: () => []
            }
        },
        data: function () {
            return {
                loadingCampuses: false,
                sending: false,
                data: {
                    name: null,
                    phone: null,
                    email: null,
                    campus: null,
                    subject: null,
                    message: null
                },
                errors: {}
            }
        },
        computed: {
            campuses: getters.campuses
        },
        methods: {
            handleChange: function (name) {
                delete this.errors[name];
            },
            handleSubmit: async function () {
                let {name, phone, email, campus, subject, message} = this.data,
                    data = {
                        name,
                        email,
                        phone,
                        campus_id: campus?.id,
                        subject,
                        message,
                        type: this.type
                    },
                    errors = validate(data, {
                        name: [Rules.required()],
                        email: [Rules.required(), Rules.email()],
                        phone: [Rules.nullable(), Rules.phone()],
                        campus_id: [Rules.required(), Rules.oneOf(this.campuses.map(campus => campus.id))],
                        subject: [
                            this.subjects.length > 0 ? Rules.required() : Rules.nullable(),
                            Rules.oneOf(this.subjects)
                        ],
                        message: [Rules.required(), Rules.minLength(30)]
                    });

                if (!isEmpty(errors)) {
                    this.errors = errors;
                    return;
                }

                this.sending = true;

                try {
                    await this.$recaptchaLoaded();
                    data['g-recaptcha-response'] = await this.$recaptcha('contact');

                    await Api.post('/contact', data);
                    this.errors = {};
                    this.data = {
                        name: this.$user?.profile?.name,
                        phone: this.$user?.profile?.phone,
                        email: this.$user?.email,
                        campus: null,
                        subject: null,
                        message: null
                    };
                    this.sending = false;
                    ModalBus.alertSuccess('Message envoyé', 'Nous vous remercions de nous avoir contacté, votre message sera traité dans les meilleurs délais.');
                } catch (err) {
                    if (err.response?.data?.errors) {
                        this.errors = err.response.data.errors;
                        this.sending = false;
                    } else {
                        ModalBus.processingError();
                    }
                }
            }
        },
        async created() {
            if(!this.$user && Token.has()){
                await actions.fetchUser();
            }

            this.data = {
                ...this.data,
                name: this.$user?.profile?.name,
                phone: this.$user?.profile?.phone,
                email: this.$user?.email
            };

            if (this.campuses.length <= 0) {
                this.loadingCampuses = true;
                await actions.fetchCampuses();
                this.loadingCampuses = false;
            }
        }
    }
</script>
